import { Stage } from '@eventbrite/webapp-constants';
import { GIRL_SCOUTS_USA_ORGANIZERS } from './girlScoutsUSAOrganizers';

export const PROJECT_NAME = 'eb-ui-mono';
export const RESOURCE_NAME = 'listings-webapp';

export const QUERY_PARAMS = {
  FORCE_ERROR: 'force-error',
  AFFILIATE_CODE: 'aff',
  WAITLIST_TOKEN: 'w',
  MIPA: 'mipa',
};

export const CORE_HOSTS: Record<string, string> = {
  [Stage.LOCAL]: 'localhost',
  [Stage.TEST]: 'evbqa.com',
  [Stage.PROD]: 'eventbrite.com',
};

export const DEV_STAGES = [Stage.LOCAL];

// This is a blocklist for excluding high profile organizers who do
// not want the get_related_events feature shown on their listings
// This list can also be found in https://github.com/eventbrite/search_service/blob/main/search_service/common/constants/get_related_events_blocklist.py#L17
// The idea is to use this list sparingly and only for high profile organizers who specifically request for it.
export const ORGANIZERIDS_EXCLUDE: Record<string, string[]> = {
  [Stage.PROD]: [
    '64445481493', // added 20230628 'Moses Lake Temple' orgid=1503802633323
    '23418369060', // added 20230718 'Ted Macaluso' orgid=309966940785 EB-225728
    '66927575373', // added 20230718 'Temple Department' CoLDS orgid=1551159597713 EB-225728
    '65797691163', // added 20230829 'the-utah-area-ysa' CoLDS orgid=1551159597713 EB-225728
    '71080805893', // added 20231204 'Intermountain...' orgid=1758676397673 EB-237360
    '29446193521', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '33640155177', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '29697999913', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '76802821573', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '51878695483', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '75120839543', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '70095385903', // added 20240805 'PADI AMERICAS' orgid=1722850217693 EB-257583
    '71641241673', // added 20240805 'PADI Asia Pacific Instructor Development' orgid=1776943206483 EB-257583
    '87780843543', // added 20240805 'Cosmo Prof' orgid=2218556823153 EB-257583

    // added 20260923
    // This is one Eventbrite account with many organizer profiles - every
    // branch is listed so the whole account is covered.
    // They are a professional engineering body and dating/sex-type adverts
    // were showing on their event and checkout pages, unrelated to the event
    // being viewed. The ask is temporary: remove these ids once ads are
    // matched by meaning rather than shared words.
    '17609493588', // Institution of Civil Engineers (head office)
    '121041520840', // Institution of Civil Engineers London, South East & East of England
    '68146357543', // Institution of Civil Engineers Scotland
    '120989000755', // Institution of Civil Engineers South West
    '115054042841', // Institution of Civil Engineers South West
    // 120960373759 'ICE Aberdeen' was removed 20261001: it belongs to Sport
    // Aberdeen (junior sports and ice skating), not the Institution of Civil Engineers.
    '114658100511', // Institution of Civil Engineers Northern Ireland
    '121149570933', // Institution of Civil Engineers Benevolent Fund
    '121508595636', // Institution of Civil Engineers, Hong Kong
    '120750501868', // Institution of Civil Engineers North West
    '120767939080', // Institution of Civil Engineers East and West Midlands
    '120761168012', // Institution of Civil Engineers East and West Midlands
    '115666590871', // Institution of Civil Engineers East Midlands early careers network
    '121630019696', // Institution of Civil Engineers (Wales)
    '109273560741', // Institution of Civil Engineers North East / Yorkshire & Humber
    '25265834421', // Institution of Civil Engineers Merseyside
    '113837878871', // Institution of Civil Engineers Glasgow & West of Scotland
    '114232139511', // Institution of Civil Engineers Glasgow and West of Scotland
    '14489884120', // Institution of Civil Engineers Scotland Museum Committee
    '88425726343', // Institution of Civil Engineers Australasia
    '121549422437', // Institution of Civil Engineers International
    '30687271678', // Institution of Civil Engineers Malaysia
    '61909432553', // Institution of Civil Engineers Malaysia Graduate Network
    '29090021649', // Institution of Civil Engineers Middle East and North Africa
    '33855838465', // Institution of Civil Engineers Victorian Local Association
    '28545963717', // Institution of Civil Engineers New York Metropolitan Local Association
    '120329735981', // Institution of Civil Engineers Gulf Coast Region
    '120378364011', // Institution of Civil Engineers USA Mid-Atlantic South Region
    '115166001101', // The Institution of Civil Engineers (Ontario, Canada)
    '120642104360', // Institution of Civil Engineers
    '11042321941', // Institution of Civil Engineers South Australia

    // added 20261001
    // Follow-up to the block above. The customer relayed 13 account numbers,
    // and each account owns one or more organizer profiles. These are the
    // profiles from those accounts that were not already listed.
    // Not included: the Welsh ICE profiles (3300021574, 34088187603,
    // 2652007004). The customer confirmed Welsh ICE is a different organisation.
    '120628383985', // Membership Support - runs Institution of Civil Engineers courses
    '118013082131', // British Geotechnical Association - associated society of the Institution of Civil Engineers
    '121674105149', // British Geotechnical Association (BGA)
    '121175843563', // British Hydrological Society - associated society of the Institution of Civil Engineers
    '120988888978', // profile name not set, owned by the ICE South West account
    ...GIRL_SCOUTS_USA_ORGANIZERS,
  ],
  [Stage.TEST]: [],
  [Stage.LOCAL]: [],
};

export const PRIVATE_ORG_DIVISOR = 1007;
